import React from 'react';

const NavigationSectionGroup: React.FC = ({ children }) => (
  <div className="group text-preset-7 flex items-center rounded-md py-2 px-2 font-medium uppercase text-gray-400">
    {children}
  </div>
);

export default NavigationSectionGroup;
